var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewsMedia = function SvgNewsMedia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M17 28.477V6.094c0-.695.3-1.357.824-1.815a12.06 12.06 0 0 1 7.392-2.97l5.354-.244A1.37 1.37 0 0 1 32 2.432V24.86c0 .62-.52 1.113-1.139 1.08l-2.785-.146a14.43 14.43 0 0 0-9.898 3.242.722.722 0 0 1-1.178-.559",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15 28.477V6.094c0-.695-.3-1.357-.824-1.815a12.06 12.06 0 0 0-7.392-2.97L1.43 1.064A1.37 1.37 0 0 0 0 2.432V24.86c0 .62.52 1.113 1.139 1.08l2.785-.146a14.43 14.43 0 0 1 9.898 3.242.722.722 0 0 0 1.178-.559"
  })));
};
export default SvgNewsMedia;